import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        servicoEnfermagem: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/servico-enfermagem/autocomplete?${urlUtil.serialize(queryParms)}`)
            },
        },
        getOcupacoes(infraestruturaId, usuarioId) {
            return repository.get(`${baseUrl}/ocupacao/${infraestruturaId}/${usuarioId}`)
        }
    }
}